import Vue from 'vue'
import VueRouter from 'vue-router'
import util from "../common/util"
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

let routes = []
let routerContext
if(util.isMobile()){
    routerContext = require.context('./m/', false, /.index.js$/)
}else{
    routerContext = require.context('./pc/', false, /.index.js$/)
}

routerContext.keys().forEach(route => {
    const routerModule = routerContext(route)
    // 兼容 import export 和 require module.export 两种规范  Es modules  commonjs
    routes = [...routes, ...(routerModule.default || routerModule)]
})


const router = new VueRouter({
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes
})

export default router
